import { render } from "./TableDataTable.vue?vue&type=template&id=5cda0097&scoped=true"
import script from "./TableDataTable.vue?vue&type=script&lang=js"
export * from "./TableDataTable.vue?vue&type=script&lang=js"

import "./TableDataTable.vue?vue&type=style&index=0&id=5cda0097&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2326401477/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cda0097"]])

export default __exports__